import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  categoryGrid: "resourceCategoriesGrid",
};

export default class SwivuSettingsResourceCategoryTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsResourceCategoryTab";
  }

  static get type() {
    return "swivusettingsresourcecategorytab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.resourceCategoryTab;
  }

  getStoreName() {
    return STORE_KEYS.resourceTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.category]: GRID_KEYS.categoryGrid,
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.categoryGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Resources",
      scrollable: true,
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.categoryGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Resource Categories",
          defaultValue: "Enter Category"
        }),
      }
    };
  }
}

SwivuSettingsResourceCategoryTab.initClass();
